import { FeatureFlag } from '@ps/web-core-enums';
import { StarsButton, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import { GameView, ViewToggle, useSaveLastUsedPath } from '@swf/poker';

import PowerPathLogo from '../../assets/power-path.png';
import { ModalRoutes, NAVIGATION_TABS_TYPE_URL_MAP } from '../../types/index';
import ListView from '../ListView/ListView';
import Steps from '../Steps/Steps';

import {
  TXTCLI_How_it_worksX,
  TXTCLI_Win_at_one_Step_and_you_could__ELL
} from './ThePath.messages.json';
import styles from './ThePath.scss';

const ThePath = () => {
  const { modal } = useDispatch<Dispatch>();
  const viewToggleEnabled = useFeature(FeatureFlag.PKRPowerPathListViewToggle);
  const { view: activeView } = useSelector(select.cms.getUrlParams);
  const [view, setView] = useState<GameView.List | GameView.Grid>(
    activeView === GameView.List ? GameView.List : GameView.Grid
  );
  const isEmbedded = useSelector(select.device.isEmbedded);
  let ViewLayout: React.ReactElement;

  switch (view) {
    case GameView.List:
      ViewLayout = <ListView />;
      break;
    default:
      ViewLayout = <Steps />;
  }

  const handleHowPlayClicked = () => modal.enqueue({ path: ModalRoutes.HowItWorks });

  const setUrlPath = useSaveLastUsedPath();

  const handleChangeView = (updatedView: GameView) => {
    const newView = updatedView === GameView.Grid ? GameView.Grid : GameView.List;

    setView(newView);
    setUrlPath(`${NAVIGATION_TABS_TYPE_URL_MAP.thePath}/${newView}`);
  };

  return (
    <div
      className={classNames(styles.path, {
        [styles.embedded]: isEmbedded
      })}
    >
      <img src={PowerPathLogo} alt="" className={styles.logo} />
      <p className={styles.info}>
        <Translation {...TXTCLI_Win_at_one_Step_and_you_could__ELL} />{' '}
        <StarsButton
          type="button"
          variant="text"
          translation={TXTCLI_How_it_worksX}
          className={styles.linkText}
          onClick={handleHowPlayClicked}
        />
      </p>
      {viewToggleEnabled && (
        <ViewToggle
          id="power-path-view"
          classes={{ container: styles.viewToggle }}
          selected={view}
          handleSelect={handleChangeView}
          config={{
            [GameView.Grid]: {
              alias: 'pokerPowerPath',
              values: { tab: NAVIGATION_TABS_TYPE_URL_MAP.thePath, view: GameView.Grid }
            },
            [GameView.List]: {
              alias: 'pokerPowerPath',
              values: { tab: NAVIGATION_TABS_TYPE_URL_MAP.thePath, view: GameView.List }
            }
          }}
        />
      )}
      <div className={styles.viewWrapper}>{ViewLayout}</div>
    </div>
  );
};

export default ThePath;
